import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';

const GenericListHeader = ({
  id,
  title,
  desc,
  search,
  onChange,
  searchText,
  searchPlaceholder,
  searchInputSize,
  button,
  buttonId,
  buttonText,
  buttonOnClick,
}) => (
  <styles.Container>
    <styles.ButtonContainer>
      <styles.Info>
        <styles.Title className="list-header-title">{title}</styles.Title>
        <styles.Desc className="list-header-description">{desc}</styles.Desc>
      </styles.Info>

      {button && (
        <styles.Button type="button" id={buttonId} onClick={buttonOnClick}>
          {buttonText}
        </styles.Button>
      )}
    </styles.ButtonContainer>

    {search && (
      <styles.InputContainer inputSize={searchInputSize}>
        <styles.InputSearch
          id={id}
          type="text"
          onChange={onChange}
          value={searchText}
          placeholder={searchPlaceholder}
          debounceTimeout={150}
        />
        <styles.SearchIcon />
      </styles.InputContainer>
    )}
  </styles.Container>
);

GenericListHeader.defaultProps = {
  placeholder: 'Pesquise',
  inputSize: '60%',
  search: true,
};

GenericListHeader.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.any,
  searchText: PropTypes.string,
  onChange: PropTypes.func,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  search: PropTypes.bool,
};

export default GenericListHeader;



// WEBPACK FOOTER //
// ./src/components/GenericListHeader/index.js